module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dofBadge",
    class: [_vm.activeBoxPosClass, _vm.activeBoxClass],
    style: _vm.badgeStyle
  }, [(!_vm.dot) ? _c('text', {
    class: ['text-desc', _vm.activeTextClass]
  }, [_vm._v(_vm._s(_vm.contentValue))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-1ff3d940!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-badge/index.vue
// module id = 589
// module chunks = 0 1